<template>
<v-dialog v-model="show"
	scrollable
	id="notification-modal"
	max-width="800" persistent :fullscreen="fullscreen"
>
	<v-card>

		<!--Modal Title -->
		<v-toolbar flat v-bind:class="{'green lighten-3': !$vuetify.theme.dark, 'grey darken-2': $vuetify.theme.dark }">
			<v-toolbar-title>{{ title }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn icon @click="show = false">
				<v-icon>mdi-window-close</v-icon>
			</v-btn>
		</v-toolbar>

		<!-- Modal Contents -->
		<v-card-text class="py-5 px-7">

			<div class="notification-content" v-html="content"></div>

		</v-card-text>

		<v-card-actions v-if="fullscreen">
			<v-spacer></v-spacer>
			<v-btn color="primary" outlined text class="mr-3" @click="show = false">
				<v-icon>mdi-window-close</v-icon> {{ $t('common.verb.close')}}
			</v-btn>
		</v-card-actions>

	</v-card>
</v-dialog>

</template>

<script>

export default {
	name: 'NotificationModal',
	props: {
		title: { type: String, required: true },
		content: { type: String, required: true },
    fullscreen: { type: Boolean, default: false},
  },
	components: {
	},
	data () {
		return {
			show: false,
		}
	},
	computed: {
	},
	methods: {
		showModal () {
			this.show = true
		},
		hideModal () {
			this.show = false
		},
	},
	created () {
	},
	beforeDestroy () {
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.notification-content {
	font-size: 15px;
}
</style>

